export default __webpack_public_path__ + "static/media/button_c.b0d60d95.png";